import { VideoVersionHistoryService } from '@src/services/videoVersions/VideoVersionHistoryService';
import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

/**
 * DI seam for `VideoVersionHistoryService`, mirroring `usePublishRecordService`.
 * Memoized on the repository so the identity is stable across renders.
 */
export function useVideoVersionHistoryService(): VideoVersionHistoryService {
  const datoClientStore = useDatoClient();
  const videoRepository = datoClientStore.videoRepository;
  return useMemo(
    () => new VideoVersionHistoryService({ videoRepository }),
    [videoRepository],
  );
}
